import { BulbOutlined } from "@ant-design/icons";
import { Card, Col } from "antd";

const InsightsCard = () => {
  return (
    <Col md={24} xs={24}>
      <Card title="💡 Insights">
        <div style={{ lineHeight: "32px" }}>
          <div style={{ color: "#2ecc71" }}>
            ● Highest win rate on Mondays (72%)
          </div>

          <div style={{ color: "#3498db" }}>
            ● Losses increase after 3 consecutive wins
          </div>

          <div style={{ color: "#f1c40f" }}>
            ● Best performance between 9:30 - 11:00 AM
          </div>
        </div>
      </Card>
    </Col>
  );
};

export default InsightsCard;